import { httpRequest, downloadFile } from './request'
import userManager from './userManager'

/**
 * 当后台有多个API端口时，根据key选择正确的端口，否则使用默认的端口
 * @param key
 * @returns {string}
 */
function getUrlByKey (key) {
  return window.ServerUrl
  // switch (key) {
  //   case 'python':
  //     return window.ServerUrl2
  //   default:
  //     return window.ServerUrl
  // }
}

/**
 * 判断接口是否需要传入 UserToken
 * @param action
 */
function actionNeedUserToken (action) {
  switch (action) {
    case '/api/Account/login':
      return false
    default:
      return true
  }
}

/**
 *
 * @param action  接口
 * @param params  参数
 * @param key  api端口
 * @returns {Promise<*>}
 */
export function httpGet (action, params, key) {
  const url = getUrlByKey(key)
  const headers = {}

  if (actionNeedUserToken(action)) {
    // headers.Authorization = `Bearer ${userManager.getToken()}`
    headers.Authorization = `${userManager.getToken()}`
  }

  return httpRequest({
    method: 'GET',
    url: url + action,
    params,
    headers
  })
}

/**
 *
 * @param action  接口
 * @param data    参数
 * @param key  api端口
 * @returns {Promise<unknown>}
 */
export function httpPost (action, data, key) {
  const url = getUrlByKey(key)
  const headers = {}

  if (actionNeedUserToken(action)) {
    // headers.Authorization = `Bearer ${userManager.getToken()}`
    headers.Authorization = `${userManager.getToken()}`
  }

  return httpRequest({
    method: 'POST',
    url: url + action,
    data,
    headers
  })
}

/**
 * 下载文件
 * @param action  接口
 * @param data    参数
 * @param key  api端口
 */
export function download (action, data, key) {
  const url = getUrlByKey(key)
  if (actionNeedUserToken(action)) {
    data.UserToken = userManager.getUserToken()
  }
  downloadFile({
    method: 'POST',
    url: url + action,
    data
  })
}

// 头部参，用于POST请求又需要URL带参情况（条件：isParam）
export function JsonToUrlParam (obj) {
  let str = ''
  if (obj) {
    str = Object.keys(obj).map(key => key + '=' + obj[key]).join('&')
    str = str ? `?${str}` : ''
  }
  return str
}
